import { AssertionDashboardPage } from '@/components/assertion-dashboard/AssertionDashboardPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/assertion/(dashboard)/')({
  component: AssertionDashboardPage,
});
